import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EFBA35",
      "fill-rule": "evenodd",
      d: "m7.861.31 2.1 4.46 4.694.715c.33.05.462.476.223.72L11.48 9.677l.802 4.902c.057.345-.289.608-.585.445L7.5 12.71l-4.198 2.314c-.296.163-.642-.1-.585-.445l.802-4.902L.122 6.205c-.239-.244-.107-.67.223-.72l4.694-.716L7.14.31a.395.395 0 0 1 .722 0"
    }, null, -1)
  ]))]))
}
export default { render: render }